import { createContext, useEffect, useRef } from "react";
import { useContext } from "react";
import { usePriceCalculation } from "../hooks/usePriceCalculation";
import { TextSectionsListContext } from "./TextSectionsListContext";

export const PriceCalculationContext = createContext(null);

export const PriceCalculationProvider = ({ children }) => {
    const { recalculateAllPrices } = usePriceCalculation();
    const textSections = useContext(TextSectionsListContext);

    // Watch for section count decreases (deletions) and auto-recalculate
    const prevLengthRef = useRef(textSections.length);
    useEffect(() => {
        if (textSections.length < prevLengthRef.current) {
            recalculateAllPrices();
        }
        prevLengthRef.current = textSections.length;
    }, [textSections.length, recalculateAllPrices]);

    return (
        <PriceCalculationContext.Provider value={{ recalculateAllPrices }}>
            {children}
        </PriceCalculationContext.Provider>
    );
};
